export * from './avatar-shape';
export * from './seo-illustration';
export * from './upload-illustration';
export * from './booking-illustration';
export * from './check-in-illustration';
export * from './check-out-illustration';
export * from './forbidden-illustration';
export * from './motivation-illustration';
export * from './coming-soon-illustration';
export * from './maintenance-illustration';
export * from './server-error-illustration';
export * from './page-not-found-illustration';
export * from './order-complete-illustration';
